module.exports = __webpack_public_path__ + "media/application/images/avatar-b3dc0b12f910602cb2f2f0dd46f8645c.svg";